'use server'

import { apiRequest, ApiResponse } from '../request'

export interface SupplierType {
    id: number
    name: string
    organizationId: number
    _count?: { suppliers: number }
    createdAt: string
    updatedAt: string
}

export async function getSupplierTypesByOrganization(
    organizationId: number,
): Promise<ApiResponse<SupplierType[]>> {
    return apiRequest<SupplierType[]>(`supplier-type/organization/${organizationId}`, {})
}

export async function getSupplierType(
    id: number,
): Promise<ApiResponse<SupplierType>> {
    return apiRequest<SupplierType>(`supplier-type/${id}`, {})
}

export async function createSupplierType(data: {
    name: string
    organizationId: number
}): Promise<ApiResponse<SupplierType>> {
    return apiRequest<SupplierType>('supplier-type', { data }, 'post')
}

export async function updateSupplierType(
    id: number,
    data: { name?: string },
): Promise<ApiResponse<SupplierType>> {
    return apiRequest<SupplierType>(`supplier-type/${id}`, { data }, 'patch')
}

export async function deleteSupplierType(
    id: number,
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`supplier-type/${id}`, {}, 'delete')
}
